module.exports = __webpack_public_path__ + "static/media/service-svg4.6af77793.svg";